// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"459":"f6e8cfbc","476":"06fe60d1","774":"98526064","858":"d95e0fcf","966":"c3846b31"}[chunkId] + ".chunk.js";
};